import { useQuery } from "@tanstack/react-query";
import { fetchSubscriptionDetails } from "../api/fetchSubscriptionDetails";

export const useSubscriptionDetails = (companyId, enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["subscriptionDetails", companyId],
    queryFn: () => fetchSubscriptionDetails(companyId),
    enabled: !!companyId && enabled,
  });

  return {
    data: data?.result || null,
    error,
    isLoading,
    refetch,
  };
};

